document.addEventListener("DOMContentLoaded", function () {

    const formDiv = document.querySelector(".klaviyo-form-TZH87C");
    const resultBtn = document.getElementById("get-my-results-btn");

    if (!formDiv || !resultBtn) return;

    let shown = false;
    const observer = new MutationObserver(() => {

        // Check if div is empty
        if (formDiv.children.length === 0) {

            // Check if the submit button or inputs still exist inside the form
            const hasInput = formDiv.querySelector('input[type="email"]');
            const hasSubmit = formDiv.querySelector('input[type="submit"]');
            if (!hasInput && !hasSubmit) {
                resultBtn.style.display = "block";
                shown = true;
                observer.disconnect(); // Clean up the observer once finished
            }
        }
    });

    observer.observe(formDiv, {
        childList: true,
        subtree: true
    });
});

// ══════════════════════════════════════════
//  PRESERVE ANSWERS
// ══════════════════════════════════════════
function saveCurrentSelections() {
    const selected = document.querySelectorAll('#branch-options .option-btn.selected');
    const values = Array.from(selected).map(b => b.textContent.trim());
    const key = state.phase === 'universal'
        ? 'universal_' + state.universalStep
        : state.branch + '_' + state.branchStep;
    state.answers[key] = values;
}

// ══════════════════════════════════════════
//  STATE
// ══════════════════════════════════════════
const state = {
    branch: null, // A–H
    branchStep: 0, // index within branch questions
    universalStep: 0, // 0 = U1, 1 = U2
    phase: 'opening', // opening | q1 | branch | universal | loading | conclusion
    answers: {},
    history: [], // screen history for back navigation
    multiSelections: {},
};

// ══════════════════════════════════════════
//  BRANCH DATA
// ══════════════════════════════════════════
const branches = {
    A: {
        label: 'Blood Pressure',
        questions: [
            {
                text: 'How long have you been dealing with your blood pressure?',
                type: 'single',
                options: [
                    "Less than a year — it's relatively new",
                    '1 to 5 years — managing it for a while',
                    'More than 5 years — part of my life a long time',
                    'My whole adult life — runs in my family too',
                ],
            },
            {
                text: "What's your current situation with medication?",
                type: 'single',
                options: [
                    "I'm not on anything yet",
                    "I'm on 1 blood pressure medication",
                    "I'm on 2+ medications — numbers still aren't right",
                    'On medication for years, mixed results',
                    "I don't want medication if I can avoid it",
                ],
            },
            {
                text: 'Which of these sounds like your experience?',
                type: 'single',
                options: [
                    "I cut salt, I walk, I do what they say — pressure still won't move",
                    "My doctor keeps adjusting prescriptions but we can't get it right",
                    'I feel fine most days but my numbers tell another story',
                    "It runs in my family — I always knew I'd have it",
                ],
            },
            {
                text: 'What have you already tried besides prescription medication?',
                type: 'multi',
                sub: 'Select all that apply',
                options: [
                    'Dietary changes — less salt, processed food',
                    'Exercise — walking, swimming, gym',
                    'Supplements or vitamins',
                    'Herbal teas or natural remedies',
                    "Nothing yet — don't know where to start",
                    'More than I can count — still here',
                ],
            },
        ],
    },
    B: {
        label: 'Energy & Fatigue',
        questions: [
            {
                text: 'How would you describe your energy most days?',
                type: 'single',
                options: [
                    'I wake up tired and never really recover',
                    'I have energy in the morning but crash by afternoon',
                    "I can push through but it costs me — I'm running on empty",
                    "I can't remember the last time I felt genuinely energized",
                ],
            },
            {
                text: 'When did your energy really start declining?',
                type: 'single',
                options: [
                    "It's been gradual — the last few years",
                    'After a health event or major stress',
                    'Around my 40s or 50s — it just dropped',
                    "I've always struggled with this",
                ],
            },
            {
                text: 'What does the fatigue cost you most?',
                type: 'single',
                options: [
                    "I can't be present with family the way I want to",
                    'My work and focus have suffered',
                    "I've stopped doing things I used to love",
                    'It affects my mood and how I treat people',
                ],
            },
            {
                text: 'What have you already tried for your energy?',
                type: 'multi',
                sub: 'Select all that apply',
                options: [
                    'More sleep / better sleep habits',
                    'Coffee or caffeine',
                    'B vitamins or energy supplements',
                    'Exercise routines',
                    'Diet changes',
                    'Nothing yet — not sure where to start',
                ],
            },
        ],
    },
    C: {
        label: 'Joint Pain & Mobility',
        questions: [
            {
                text: 'Where is the pain or stiffness mostly affecting you?',
                type: 'multi',
                sub: 'Select all that apply',
                options: [
                    'Knees',
                    'Hips',
                    'Lower back',
                    'Hands or wrists',
                    'Shoulders or neck',
                    'Multiple areas — it moves around',
                ],
            },
            {
                text: 'How much is it limiting what you can do?',
                type: 'single',
                options: [
                    'Mild — I notice it but push through',
                    'Moderate — it slows me down daily',
                    "Significant — I've had to stop activities I loved",
                    'Severe — it affects nearly everything I do',
                ],
            },
            {
                text: 'What have you tried for the pain or stiffness?',
                type: 'multi',
                sub: 'Select all that apply',
                options: [
                    'Over-the-counter pain relievers',
                    'Prescription medication',
                    'Physical therapy or stretching',
                    'Heat or ice therapy',
                    'Supplements like glucosamine or turmeric',
                    "I've tried everything — nothing sticks",
                ],
            },
            {
                text: "What's your honest belief about your joint pain?",
                type: 'single',
                options: [
                    "It's just aging — nothing will fully fix it",
                    "Something is inflamed inside that hasn't been addressed",
                    'My body is missing something it needs',
                    "I'm open to trying something different if it actually works",
                ],
            },
        ],
    },
    D: {
        label: 'Hair, Skin & Nails',
        questions: [
            {
                text: "What's the main thing you've been noticing?",
                type: 'multi',
                sub: 'Select all that apply',
                options: [
                    'Hair thinning or shedding more than usual',
                    'Dull or uneven skin tone',
                    'Dry, brittle nails that break easily',
                    "Skin that doesn't bounce back the way it used to",
                    'Hyperpigmentation or dark spots',
                    'All of the above, honestly',
                ],
            },
            {
                text: 'How long has this been noticeable?',
                type: 'single',
                options: [
                    'Just started — a few months',
                    "1–2 years — it's been gradual",
                    "Several years — it's been building",
                    'Most of my adult life',
                ],
            },
            {
                text: 'What have you already tried?',
                type: 'multi',
                sub: 'Select all that apply',
                options: [
                    'Hair growth products or serums',
                    'Biotin or hair vitamins',
                    'Skincare routines',
                    'Diet changes',
                    'Dermatologist-prescribed treatments',
                    'A lot — still not satisfied',
                ],
            },
            {
                text: 'What do you believe is behind it?',
                type: 'single',
                options: [
                    "Nutrient deficiencies I haven't addressed",
                    'Stress and inflammation inside the body',
                    "My body isn't absorbing what it needs",
                    'Genetics — runs in my family',
                ],
            },
        ],
    },
    E: {
        label: 'Blood Sugar',
        questions: [
            {
                text: "What's your current blood sugar situation?",
                type: 'single',
                options: [
                    'Prediabetic — doctor has flagged it',
                    'Type 2 diabetic — managing it',
                    'Numbers have been creeping up — not there yet',
                    "Family history of diabetes — I'm watching it",
                ],
            },
            {
                text: 'Which symptoms affect you day to day?',
                type: 'multi',
                sub: 'Select all that apply',
                options: [
                    'Energy crashes after eating',
                    'Strong sugar or carb cravings',
                    'Trouble losing weight',
                    'Fatigue throughout the day',
                    'Foggy thinking',
                    'Frequent thirst or urination',
                ],
            },
            {
                text: 'What have you tried to support your blood sugar?',
                type: 'multi',
                sub: 'Select all that apply',
                options: [
                    'Reduced sugar / low-carb eating',
                    'Metformin or prescription medication',
                    'Supplements like berberine or cinnamon',
                    'Exercise changes',
                    'Nothing yet — looking for options',
                    "Multiple things — numbers still aren't where I want them",
                ],
            },
            {
                text: 'What worries you most about where this is heading?',
                type: 'single',
                options: [
                    "Medication dependency — I don't want to be on pills forever",
                    "Long-term complications if I can't get it under control",
                    "The toll it's taking on my energy and body weight",
                    'I feel like my body is working against me',
                ],
            },
        ],
    },
    F: {
        label: 'Digestion & Gut',
        questions: [
            {
                text: "What's the main issue you deal with?",
                type: 'multi',
                sub: 'Select all that apply',
                options: [
                    'Bloating — especially after meals',
                    'Irregularity or constipation',
                    'Stomach discomfort or cramping',
                    'Acid reflux or heartburn',
                    'Feeling full or heavy all the time',
                    "Generally off — can't pinpoint it",
                ],
            },
            {
                text: 'How often does your digestion affect your day?',
                type: 'single',
                options: [
                    "Daily — it's constant",
                    'Several times a week',
                    'Flares up unpredictably',
                    "Mostly after certain foods but I don't know which ones",
                ],
            },
            {
                text: 'What have you already tried?',
                type: 'multi',
                sub: 'Select all that apply',
                options: [
                    'Probiotics',
                    'Dietary changes',
                    'Fiber supplements',
                    'Prescription or OTC antacids',
                    'Elimination diets',
                    'Nothing — been living with it',
                ],
            },
            {
                text: 'What do you think is behind the issue?',
                type: 'single',
                options: [
                    'My gut lining is inflamed or damaged',
                    'Imbalance in gut bacteria',
                    "My diet — but I don't know what to cut",
                    'Stress is a big factor',
                    "I genuinely don't know — nothing has given me a clear answer",
                ],
            },
        ],
    },
    G: {
        label: 'Weight & Metabolism',
        questions: [
            {
                text: 'How would you describe the weight situation?',
                type: 'single',
                options: [
                    "I've been gradually gaining and can't stop it",
                    'I lose weight, then gain it back — stuck in a cycle',
                    "I eat well and exercise but the scale won't move",
                    "My body has changed since a certain age and I can't reset it",
                ],
            },
            {
                text: 'What have you already tried?',
                type: 'multi',
                sub: 'Select all that apply',
                options: [
                    'Calorie restriction or tracking',
                    'Exercise programs',
                    'Keto, paleo, or low-carb eating',
                    'Weight loss supplements',
                    'Intermittent fasting',
                    'More things than I can count',
                ],
            },
            {
                text: 'What else is going on alongside the weight struggle?',
                type: 'multi',
                sub: 'Select all that apply',
                options: [
                    "Low energy — I don't have the drive to work out",
                    'Sugar or carb cravings that are hard to control',
                    'Inflammation — joints, bloating, or puffiness',
                    'Blood sugar or blood pressure issues',
                    'Poor sleep',
                    "Stress that doesn't let up",
                ],
            },
            {
                text: 'What do you believe is holding you back?',
                type: 'single',
                options: [
                    "My metabolism has slowed down and I don't know how to fix it",
                    'Inflammation inside my body is making it impossible',
                    "I'm missing nutrients that regulate appetite and energy",
                    "Hormones — something shifted and I can't get it back",
                ],
            },
        ],
    },
    H: {
        label: 'General Wellness',
        questions: [
            {
                text: 'Out of everything going on, what bothers you the most day to day?',
                type: 'single',
                options: [
                    "The fatigue — I just don't have energy anymore",
                    "The pain — my body aches in ways it didn't before",
                    'The way I look — skin, hair, weight',
                    'The worry — I know something is off but tests come back "fine"',
                ],
            },
            {
                text: 'Does your family have a history of any of these?',
                type: 'multi',
                sub: 'Select all that apply',
                options: [
                    'High blood pressure',
                    'Diabetes or blood sugar issues',
                    'Heart disease',
                    'Joint pain or arthritis',
                    'Thyroid problems',
                    "Not sure — it's not something we talked about openly",
                ],
            },
            {
                text: 'If you could feel truly better, what would change first?',
                type: 'single',
                options: [
                    "I'd have the energy to show up differently for people I love",
                    "I'd stop worrying every time I see a doctor",
                    "I'd feel comfortable in my own body again",
                    "I'd finally feel like I got my life back",
                ],
            },
        ],
    },
};

const universalQuestions = [
    {
        text: 'How long have you been looking for something that actually works?',
        type: 'single',
        options: [
            'Just started — this is early for me',
            'A year or two — tried some things, mixed results',
            "Several years — I've been around the block",
            'Most of my adult life — nothing has fully delivered',
            "Basically accepted nothing will work — but I'm here",
        ],
    },
    {
        text: "What's your honest relationship with natural remedies — what your ancestors used for their health?",
        type: 'single',
        options: [
            'I grew up around it — herbs, teas were normal in my house',
            "My grandmother's way made more sense than what's sold today",
            "I'm curious but don't know what to trust",
            'I\'ve been burned by "natural" products before — I need proof',
            'Never thought about it that way — open to it',
        ],
    },
];

// ══════════════════════════════════════════
//  PROGRESS CALCULATOR
// ══════════════════════════════════════════
function calcProgress() {
    if (state.phase === 'opening') return 0;
    if (state.phase === 'q1') return 10;
    const branchLen = branches[state.branch]?.questions.length || 4;
    const totalSteps = 1 + branchLen + 2; // q1 + branch + 2 universal
    const branchIdx = state.branchStep + 1; // steps completed in branch (0-indexed)

    if (state.phase === 'branch') {
        const done = 1 + branchIdx;
        return Math.round((done / totalSteps) * 90);
    }
    if (state.phase === 'universal') {
        const done = 1 + branchLen + state.universalStep + 1;
        return Math.round((done / totalSteps) * 90);
    }
    if (state.phase === 'conclusion') return 100;
    if (state.phase === 'email') return 95;
    return 0;
}

function updateProgress() {
    const pct = calcProgress();
    document.getElementById('progressFill').style.width = pct + '%';
}

// ══════════════════════════════════════════
//  SCREEN MANAGEMENT
// ══════════════════════════════════════════
function showScreen(id) {
    document.querySelectorAll('.screen, .loading-screen, .conclusion-card, .email-card').forEach((el) => {
        el.classList.remove('active');
        if (el.classList.contains('loading-screen') || el.classList.contains('email-card')) {
            el.style.display = 'none';
        }
    });
    const el = document.getElementById(id);
    if (el) {
        if (el.classList.contains('loading-screen') || el.classList.contains('conclusion-card')) {
            el.classList.add('active');
        } else {
            el.classList.add('active');
        }
        window.scrollTo({ top: 0, behavior: 'smooth' });
    }
}

// ══════════════════════════════════════════
//  OPTION SELECTION
// ══════════════════════════════════════════
function selectSingle(btn, context) {
    const container = btn.closest('.options');
    container.querySelectorAll('.option-btn').forEach((b) => b.classList.remove('selected'));
    btn.classList.add('selected');

    const nextId =
        context + '-next' in document.getElementById(context + '-next')
            ? context + '-next'
            : document.getElementById('branch-next')
                ? 'branch-next'
                : context + '-next';

    const nextBtn = document.getElementById(context === 'q1' ? 'q1-next' : 'branch-next');
    if (nextBtn) nextBtn.disabled = false;
}

function selectMulti(btn, context) {
    btn.classList.toggle('selected');
    const container = btn.closest('.options');
    const anySelected = container.querySelectorAll('.option-btn.selected').length > 0;
    const nextBtn = document.getElementById(context === 'q1' ? 'q1-next' : 'branch-next');
    if (nextBtn) nextBtn.disabled = !anySelected;
}

// ══════════════════════════════════════════
//  START QUIZ
// ══════════════════════════════════════════
function startQuiz() {
    state.phase = 'q1';
    document.getElementById('progressWrap').style.display = 'block';
    document.getElementById('timerBar').style.display = 'flex';
    startTimer();
    showScreen('screen-q1');
    updateProgress();
    // auto-advance on Q1
    document.querySelectorAll('#q1-options .option-btn').forEach((btn) => {
        btn.addEventListener('click', () => {
            // slight delay for visual feedback then auto-advance
            setTimeout(() => goNext(), 250);
        });
    });
}

// ══════════════════════════════════════════
//  GO NEXT
// ══════════════════════════════════════════
function goNext() {
    if (state.phase === 'q1') {
        const selected = document.querySelector('#q1-options .option-btn.selected');
        if (!selected) return;

        // Clear old branch answers if user picked a different branch
        if (state.branch && state.branch !== selected.dataset.value) {
            Object.keys(state.answers).forEach(key => {
                if (key !== 'universal_0' && key !== 'universal_1') {
                    delete state.answers[key];
                }
            });
        }

        state.branch = selected.dataset.value;
        state.branchStep = 0;
        state.history.push('q1');
        state.phase = 'branch';
        renderBranchQuestion();
        showScreen('screen-branch');
        updateProgress();
        return;
    }

    if (state.phase === 'branch') {
        saveCurrentSelections();

        const branchData = branches[state.branch];
        state.branchStep++;
        if (state.branchStep < branchData.questions.length) {
            renderBranchQuestion();
            resetBranchCard();
        } else {
            // Move to universal
            state.phase = 'universal';
            state.universalStep = 0;
            renderUniversalQuestion();
            resetBranchCard();
        }
        updateProgress();
        return;
    }

    if (state.phase === 'universal') {
        saveCurrentSelections();

        state.universalStep++;
        if (state.universalStep < universalQuestions.length) {
            renderUniversalQuestion();
            resetBranchCard();
            updateProgress();
        } else {
            // Show loading then conclusion
            showLoading();
        }
        return;
    }
}

function resetBranchCard() {
    // document.getElementById('branch-next').disabled = true;
    // window.scrollTo({ top: 0, behavior: 'smooth' });

    const key = state.phase === 'universal'
        ? 'universal_' + state.universalStep
        : state.branch + '_' + state.branchStep;

    const hasSaved = state.answers[key] && state.answers[key].length > 0;
    document.getElementById('branch-next').disabled = !hasSaved; // 👈 only disable if no saved answer
    window.scrollTo({ top: 0, behavior: 'smooth' });
}

// ══════════════════════════════════════════
//  GO BACK
// ══════════════════════════════════════════
function goBack() {
    if (state.phase === 'branch') {
        saveCurrentSelections();

        if (state.branchStep > 0) {
            state.branchStep--;
            renderBranchQuestion();
            document.getElementById('branch-next').disabled = false;
        } else {
            state.phase = 'q1';
            showScreen('screen-q1');
        }
        updateProgress();
        return;
    }
    if (state.phase === 'universal') {
        saveCurrentSelections();

        if (state.universalStep > 0) {
            state.universalStep--;
            renderUniversalQuestion();
            document.getElementById('branch-next').disabled = false;
        } else {
            state.phase = 'branch';
            state.branchStep = branches[state.branch].questions.length - 1;
            renderBranchQuestion();
            document.getElementById('branch-next').disabled = false;
        }
        updateProgress();
        return;
    }
}

// ══════════════════════════════════════════
//  RENDER BRANCH QUESTION
// ══════════════════════════════════════════
function renderBranchQuestion() {
    const branchData = branches[state.branch];
    const q = branchData.questions[state.branchStep];
    const totalQ = 1 + branchData.questions.length + universalQuestions.length;
    const currentQ = 1 + state.branchStep + 1;

    document.getElementById('branch-label').textContent =
        branchData.label + ' · Question ' + currentQ + ' of ' + totalQ;
    document.getElementById('branch-question').textContent = q.text;

    const subEl = document.getElementById('branch-sub');
    if (q.sub) {
        subEl.textContent = q.sub;
        subEl.style.display = 'block';
    } else {
        subEl.style.display = 'none';
    }

    renderOptions('branch-options', q, 'branch', q.type);
    showScreen('screen-branch');
}

// ══════════════════════════════════════════
//  RENDER UNIVERSAL QUESTION
// ══════════════════════════════════════════
function renderUniversalQuestion() {
    const q = universalQuestions[state.universalStep];
    const branchLen = branches[state.branch].questions.length;
    const totalQ = 1 + branchLen + universalQuestions.length;
    const currentQ = 1 + branchLen + state.universalStep + 1;
    const isLast = state.universalStep === universalQuestions.length - 1;

    document.getElementById('branch-label').textContent =
        (state.universalStep === 0 ? 'Almost Done' : 'Last Question') + ' · Question ' + currentQ + ' of ' + totalQ;
    document.getElementById('branch-question').textContent = q.text;
    document.getElementById('branch-sub').style.display = 'none';

    renderOptions('branch-options', q, 'branch', q.type);

    const nextBtn = document.getElementById('branch-next');
    nextBtn.textContent = isLast ? 'See My Results →' : 'Next';
    showScreen('screen-branch');
}

// ══════════════════════════════════════════
//  RENDER OPTIONS
// ══════════════════════════════════════════
function renderOptions(containerId, q, context, type) {
    const container = document.getElementById(containerId);
    container.innerHTML = '';

    // Build the answer key for this question
    const key = state.phase === 'universal'
        ? 'universal_' + state.universalStep
        : state.branch + '_' + state.branchStep;

    const savedAnswers = state.answers[key] || [];

    q.options.forEach((opt) => {
        const btn = document.createElement('button');
        btn.className = 'option-btn';

        const indicator = document.createElement('div');
        indicator.className = type === 'multi' ? 'check-box' : 'radio-dot';

        const text = document.createTextNode(opt);
        btn.appendChild(indicator);
        btn.appendChild(text);

        // 👇 Restore saved selection
        if (savedAnswers.includes(opt)) {
            btn.classList.add('selected');
        }

        if (type === 'multi') {
            btn.addEventListener('click', () => selectMulti(btn, context));
        } else {
            btn.addEventListener('click', () => {
                selectSingle(btn, context);
                setTimeout(() => goNext(), 280);
            });
        }

        container.appendChild(btn);
    });

    // 👇 Re-enable Next button if something was already selected
    const nextBtn = document.getElementById('branch-next');
    nextBtn.disabled = savedAnswers.length === 0;
    nextBtn.textContent = 'Next';
}

// ══════════════════════════════════════════
//  SHOW EMAIL GATE
// ══════════════════════════════════════════
function showEmailGate() {
    document.querySelectorAll('.screen, .loading-screen, .conclusion-card, .email-card').forEach((el) => {
        el.classList.remove('active');
        if (el.classList.contains('loading-screen') || el.classList.contains('email-card')) {
            el.style.display = 'none';
        }
    });
    state.phase = 'email';
    updateProgress();
    const emailEl = document.getElementById('screen-email');
    emailEl.style.display = 'block';
    emailEl.classList.add('active');
    window.scrollTo({ top: 0, behavior: 'smooth' });
}

// ══════════════════════════════════════════
//  SUBMIT EMAIL → LOADING → CONCLUSION
// ══════════════════════════════════════════
function submitEmail() {

    // Hide email gate, show loading
    const emailEl = document.getElementById('screen-email');
    emailEl.classList.remove('active');
    emailEl.style.display = 'none';

    const loadEl = document.getElementById('screen-loading');
    loadEl.style.display = 'block';
    loadEl.classList.add('active');
    window.scrollTo({ top: 0, behavior: 'smooth' });

    setTimeout(() => {
        loadEl.style.display = 'none';
        loadEl.classList.remove('active');
        state.phase = 'conclusion';

        const offerBtn = document.getElementById('offerBtn');
        offerBtn.href =
            'https://infiniteage.com/pages/chondrus-crispus-sea-moss-sub-offer?src=quiz&branch=' + state.branch;

        document.getElementById('screen-conclusion').classList.add('active');
        updateProgress();
        window.scrollTo({ top: 0, behavior: 'smooth' });
    }, 2000);
}

// ══════════════════════════════════════════
//  LOADING → CONCLUSION (legacy, now routes to email first)
// ══════════════════════════════════════════
function showLoading() {
    showEmailGate();
}

// ══════════════════════════════════════════
//  COUNTDOWN TIMER
// ══════════════════════════════════════════
function startTimer() {
    let seconds = 9 * 60; // 9 minutes
    const display = document.getElementById('timerDisplay');
    const interval = setInterval(() => {
        if (seconds <= 0) {
            clearInterval(interval);
            display.textContent = '00:00';
            return;
        }
        seconds--;
        const m = Math.floor(seconds / 60)
            .toString()
            .padStart(2, '0');
        const s = (seconds % 60).toString().padStart(2, '0');
        display.textContent = m + ':' + s;
    }, 1000);
}

// Fix: make Q1 options work with the selectSingle approach
document.querySelectorAll('#q1-options .option-btn').forEach((btn) => {
    btn.addEventListener('click', function () {
        document.querySelectorAll('#q1-options .option-btn').forEach((b) => b.classList.remove('selected'));
        this.classList.add('selected');
        document.getElementById('q1-next').disabled = false;
    });
});